__turbopack_context__.v({
  "india": "NavigationLogo-module-scss-module__axKgSG__india",
  "logoWrapper": "NavigationLogo-module-scss-module__axKgSG__logoWrapper",
  "siteLabel": "NavigationLogo-module-scss-module__axKgSG__siteLabel",
});
